import AjaxSearch from "./ajaxSearch";

new AjaxSearch();